import { withLazy } from 'app/hocs/withLazy'

export const ShopOption = withLazy(() => import('features/Option/pages/ShopOption'))
